import type { StatsHighlightDto } from '@vmt/shared';
import { Award } from 'lucide-react';
import { Link } from 'react-router-dom';

/** "Awards": best player per category. */
export function Highlights({ items }: { items: StatsHighlightDto[] }) {
  if (!items.length) return null;
  return (
    <ul className="grid grid-cols-2 gap-2 lg:grid-cols-4">
      {items.map((h) => (
        <li key={h.key} className="clip-corner-sm border border-ink-700/60 bg-ink-900 p-3">
          <div className="flex items-center gap-1.5 text-[11px] font-semibold tracking-wider text-ink-400 uppercase">
            <Award className="size-3.5 text-warning" aria-hidden />
            {h.label}
          </div>
          <div className="mt-1 font-display text-2xl leading-none font-bold">
            {h.value.toLocaleString('de-DE')}{' '}
            <span className="text-sm font-semibold text-ink-400">{h.unit}</span>
          </div>
          <Link
            to={`/players/${h.playerId}`}
            className="mt-1 block truncate text-sm font-medium hover:text-accent"
          >
            {h.displayName}
          </Link>
          <div className="text-xs text-ink-500">{h.context}</div>
        </li>
      ))}
    </ul>
  );
}
